import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "prompt-handler" }
const _hoisted_2 = { class: "as-pre" }
const _hoisted_3 = {
  key: 0,
  class: "buttons"
}
const _hoisted_4 = { class: "options" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select an option", -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "buttons" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "options" }
const _hoisted_10 = { class: "buttons" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "log" }
const _hoisted_13 = { class: "buttons" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 4,
  class: "buttons"
}
const _hoisted_16 = {
  key: 0,
  disabled: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.currentPrompt)
    ? (_openBlock(), _createBlock($setup["SimpleModal"], {
        key: 0,
        "click-to-close": false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h2", null, _toDisplayString($setup.currentPrompt.header), 1),
            _createElementVNode("p", _hoisted_2, _toDisplayString($setup.currentPrompt.body), 1),
            ($setup.currentPrompt.type === 'YesNo')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("button", {
                    class: "g-warning",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.handleYesNo(false)))
                  }, "No"),
                  _createElementVNode("button", {
                    class: "g-save",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.handleYesNo(true)))
                  }, "Yes")
                ]))
              : ($setup.currentPrompt.type === 'Choice')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_4, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.responseValue) = $event))
                      }, [
                        _hoisted_5,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.currentPrompt.options || [], (option) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: option.value,
                            value: option.value
                          }, _toDisplayString(option.display), 9, _hoisted_6))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, $setup.responseValue]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("button", {
                        class: "g-borderless",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => {$setup.responseValue = null; $setup.handleChoice()})
                      }, "Cancel"),
                      _createElementVNode("button", {
                        class: "g-save",
                        disabled: !$setup.responseValue,
                        onClick: $setup.handleChoice
                      }, "Submit", 8, _hoisted_8)
                    ])
                  ], 64))
                : ($setup.currentPrompt.type === 'Query')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createElementVNode("div", _hoisted_9, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.responseValue) = $event))
                        }, null, 512), [
                          [_vModelText, $setup.responseValue]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("button", {
                          class: "g-borderless",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => {$setup.responseValue = null; $setup.handleQuery(null)})
                        }, "Cancel"),
                        _createElementVNode("button", {
                          class: "g-save",
                          disabled: !$setup.responseValue,
                          onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.handleQuery($setup.responseValue)))
                        }, "Submit", 8, _hoisted_11)
                      ])
                    ], 64))
                  : ($setup.currentPrompt.type === 'Log')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createElementVNode("pre", _hoisted_12, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(($setup.currentPrompt.logItems?.value || []), (item, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: _normalizeClass(["item", [item.type]]),
                              key: i
                            }, _toDisplayString(item.value), 3))
                          }), 128))
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("button", {
                            class: "g-save",
                            disabled: !$setup.currentPrompt.canClose,
                            onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.handleAck()))
                          }, "Close", 8, _hoisted_14)
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                        ($setup.count > 0)
                          ? (_openBlock(), _createElementBlock("button", _hoisted_16, "Waiting (" + _toDisplayString($setup.count) + ")", 1))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              class: "g-save",
                              onClick: $setup.handleAck
                            }, "OK"))
                      ]))
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}